import { n } from "./property-9daa16cd.mjs";
import { e as d } from "./query-d94c86d2.mjs";
import { e as b } from "./class-map-2994e95e.mjs";
import { i as u, E as v, x, d as g } from "./createReactComponent-58f9bea8.mjs";
const h = u`
  /** LIGHT MODE */

  :host .button,
  :host a {
    font: var(--exo-text-label-standard-semi-bold);
    line-height: var(--exo-line-height-denser);
    color: var(--exo-color-font-inverse);
    background-color: var(--exo-color-background-selected);
    border: var(--exo-spacing-4x-small);
    height: var(--exo-spacing-x-large);
    border-radius: var(--exo-spacing-2x-small);
    cursor: pointer;
    transition: background-color var(--exo-time-standard) ease;
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-small);
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    box-sizing: border-box;
    position: relative;
  }

  :host .button {
    width: 100%;
  }

  :host .button .button--content {
    display: flex;
    align-items: center;
  }

  /*CSS for base flavor starts here*/

  :host .button:hover {
    background-color: var(--exo-color-background-selected-hover);
  }

  :host .button:active {
    background-color: var(--exo-color-background-selected);
  }

  :host .button:focus-visible {
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    background-color: var(--exo-color-background-selected-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected-hover);
  }

  :host .button.button--secondary {
    background-color: var(--exo-color-background-action-secondary);
    color: var(--exo-color-background-selected);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-selected);
  }

  :host .button.button--secondary:hover {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-selected-hover);
    color: var(--exo-color-background-selected-hover);
    background-color: var(--exo-color-background-action-secondary-hover);
  }

  :host .button.button--secondary:active {
    background-color: var(--exo-color-background-action-secondary);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-selected-hover);
  }

  :host .button.button--secondary:focus-visible {
    background-color: var(--exo-color-background-action-secondary-hover);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    color: var(--exo-color-background-selected-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
  }

  :host .button.button--tertiary {
    background: none;
    color: var(--exo-color-background-selected);
    border: none;
  }

  :host .button.button--tertiary:hover {
    background-color: var(--exo-color-background-action-secondary-hover);
    color: var(--exo-color-background-selected-hover);
  }

  :host .button.button--tertiary:active {
    background: var(--exo-color-background-action-secondary);
  }

  :host .button.button--tertiary:focus-visible {
    background-color: var(--exo-color-background-action-secondary-hover);
    color: var(--exo-color-background-selected-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
  }

  /** CSS for Button Size */

  :host .button--size-large {
    font: var(--exo-text-label-medium-semi-bold);
    padding: var(--exo-spacing-x-small) var(--exo-spacing-small);
    height: calc(0.5 * var(--exo-size-1));
    line-height: var(--exo-line-height-denser);
  }

  :host .button--size-small {
    font: var(--exo-text-label-micro);
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-x-small);
    height: calc(0.3 * var(--exo-size-1));
  }

  :host .button.button--size-large:focus-visible {
    outline-width: var(--exo-spacing-3x-small);
  }

  /*CSS for Tab flavor starts here*/

  :host .button--tab.button--tertiary {
    background: none;
    border: none;
    color: var(--exo-color-font);
    padding: 0;
  }

  :host .button--tab.button--tertiary:hover {
    background: none;
    color: var(--exo-color-font);
  }

  :host .button--tab.button--tertiary:active {
    background: none;
  }

  /*CSS for Boomi AI flavor starts here*/

  :host .button--periwinkle.button--primary {
    background-color: var(--exo-color-surface-ai-action);
    color: var(--exo-color-font-inverse);
  }

  :host .button--periwinkle.button--primary:hover {
    background-color: var(--exo-color-surface-ai-action-hover);
  }

  :host .button--periwinkle.button--primary:active {
    background-color: var(--exo-color-surface-ai-action);
  }

  :host .button--periwinkle.button--primary:focus-visible {
    background-color: var(--exo-color-surface-ai-action-hover);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-surface-ai-action);
  }

  :host .button--periwinkle.button--secondary {
    background-color: var(--exo-color-background-action-secondary);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
    color: var(--exo-color-surface-ai-action);
  }

  :host .button--periwinkle.button--secondary:hover {
    background-color: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-surface-ai-action-hover);
    color: var(--exo-color-surface-ai-action-hover);
  }

  :host .button--periwinkle.button--secondary:active {
    background-color: var(--exo-color-background-action-secondary);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
  }

  :host .button--periwinkle.button--secondary:focus-visible {
    background-color: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    color: var(--exo-color-surface-ai-action-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-surface-ai-action);
  }

  :host .button--periwinkle.button--tertiary {
    background: none;
    border: none;
    color: var(--exo-color-surface-ai-action);
  }

  :host .button--periwinkle.button--tertiary:hover {
    background-color: var(--exo-color-background-action-hover-weak);
    color: var(--exo-color-surface-ai-action-hover);
  }

  :host .button--periwinkle.button--tertiary:active {
    background-color: var(--exo-color-background-action-secondary);
  }

  :host .button--periwinkle.button--tertiary:focus-visible {
    background-color: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    color: var(--exo-color-surface-ai-action-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-surface-ai-action);
  }

  /*CSS for branded flavor starts here*/

  :host .button--branded.button--primary {
    background-color: var(--exo-color-background-selected);
    color: var(--exo-color-font-inverse);
  }

  :host .button--branded.button--primary:hover {
    background-color: var(--exo-color-background-selected-hover);
  }

  :host .button--branded.button--primary:active {
    background-color: var(--exo-color-background-selected);
  }

  :host .button--branded.button--primary:focus-visible {
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    background-color: var(--exo-color-background-selected-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected-hover);
  }

  :host .button--branded.button--secondary {
    background-color: var(--exo-color-background-action-secondary);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
    color: var(--exo-color-background-action);
  }

  :host-context(.ex-theme-dark) .button--branded.button--secondary {
    color: var(--exo-color-font-tertiary);
  }

  :host .button--branded.button--secondary:hover {
    background-color: var(--exo-color-background-action-hover-weak);
    border-color: var(--exo-color-background-action-hover);
    color: var(--exo-color-background-action-hover);
  }

  :host .button--branded.button--secondary:active {
    background-color: var(--exo-color-background-action-secondary);
    border-color: var(--exo-color-background-action);
  }

  :host .button--branded.button--secondary:focus-visible {
    background-color: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    color: var(--exo-color-background-action-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
  }

  :host .button--branded.button--tertiary {
    background: none;
    border: var(--exo-spacing-4x-small) solid transparent;
    color: var(--exo-color-background-action);
  }

  :host .button--branded.button--tertiary:hover {
    background-color: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
    color: var(--exo-color-background-action-hover);
  }

  :host .button--branded.button--tertiary:active {
    background-color: var(--exo-color-background-action-secondary);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
  }

  :host .button--branded.button--tertiary:focus-visible {
    background-color: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    color: var(--exo-color-background-action-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
  }

  /*CSS for risky flavor starts here*/

  :host .button--risky.button--primary {
    background-color: var(--exo-color-background-danger-strong);
    color: var(--exo-color-font-inverse);
  }

  :host .button--risky.button--primary:hover {
    background-color: var(--exo-color-background-danger-strong-hover);
  }

  :host .button--risky.button--primary:active {
    background-color: var(--exo-color-background-danger-strong);
  }

  :host .button--risky.button--primary:focus-visible {
    background-color: var(--exo-color-background-danger-strong-hover);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-danger-strong);
  }

  :host .button--risky.button--secondary {
    background-color: var(--exo-color-background-action-secondary);
    border-color: var(--exo-color-border-danger-strong);
    color: var(--exo-color-font-danger);
  }

  :host-context(.ex-theme-dark) .button--risky.button--secondary {
    border-color: var(--exo-color-border-danger-extreme);
    color: var(--exo-color-border-danger-extreme);
  }

  :host .button--risky.button--secondary:hover {
    border-color: var(--exo-color-border-danger-extreme);
    background-color: var(--exo-color-background-danger-weak);
    color: var(--exo-color-background-danger-strong-hover);
  }

  :host .button--risky.button--secondary:active {
    border-color: var(--exo-color-border-danger-extreme);
    background-color: var(--exo-color-background-action-secondary);
  }

  :host .button--risky.button--secondary:focus-visible {
    background-color: var(--exo-color-background-danger-weak);
    color: var(--exo-color-background-danger-strong-hover);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-danger-strong);
  }

  :host .button--risky.button--tertiary {
    background: none;
    border: none;
    color: var(--exo-color-font-danger);
  }

  :host .button--risky.button--tertiary:hover {
    background-color: var(--exo-color-background-danger-weak);
    color: var(--exo-color-background-danger-strong-hover);
  }

  :host .button--risky.button--tertiary:active {
    color: var(--exo-color-background-danger-strong);
    background: var(--exo-color-background-action-secondary);
  }

  :host .button--risky.button--tertiary:focus-visible {
    background-color: var(--exo-color-background-danger-weak);
    color: var(--exo-color-background-danger-strong-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-danger-strong);
  }

  :host [disabled].button {
    pointer-events: none;
    cursor: not-allowed;
    color: var(--exo-color-font-inverse);
  }

  :host [disabled].button.button--primary {
    background-color: var(--exo-color-background-disabled);
    border-color: var(--exo-color-background-disabled);
  }

  :host [disabled].button.button--secondary {
    border-color: var(--exo-color-background-disabled);
    color: var(--exo-color-background-disabled);
    background-color: var(--exo-color-background-action-secondary);
  }

  :host [disabled].button.button--tertiary {
    color: var(--exo-color-background-disabled);
  }

  :host([disabled]) .button.button--primary ::slotted(ex-icon[slot="prefix"]),
  :host([disabled]) .button.button--primary ::slotted(ex-icon[slot="suffix"]) {
    color: var(--exo-color-icon-inverse);
  }

  ::slotted(ex-icon:first-child),
  ::slotted(ex-icon:last-child),
  ::slotted(ex-loader:first-child),
  ::slotted(ex-loader:last-child) {
    position: relative;
  }

  ::slotted(ex-icon[slot="prefix"]),
  ::slotted(ex-loader[slot="prefix"]) {
    font-size: var(--exo-font-size-medium);
    margin-right: var(--exo-spacing-2x-small);
  }

  ::slotted(ex-icon[slot="suffix"]),
  ::slotted(ex-loader[slot="suffix"]) {
    font-size: var(--exo-font-size-medium);
    margin-left: var(--exo-spacing-2x-small);
  }

  :host .button--size-large ::slotted(ex-icon[slot="prefix"]) {
    font-size: var(--exo-font-size-3x-large);
  }

  :host([disabled]) {
    pointer-events: none;
  }
`;
var k = Object.defineProperty, p = Object.getOwnPropertyDescriptor, t = (o, r, l, c) => {
  for (var s, a = c > 1 ? void 0 : c ? p(r, l) : r, i = o.length - 1; i >= 0; i--)
    (s = o[i]) && (a = (c ? s(r, l, a) : s(a)) || a);
  return c && a && k(r, l, a), a;
}, y = ((o) => (o.PRIMARY = "primary", o.SECONDARY = "secondary", o.TERTIARY = "tertiary", o))(y || {}), m = ((o) => (o.BASE = "base", o.PERIWINKLE = "periwinkle", o.BRANDED = "branded", o.RISKY = "risky", o.TAB = "tab", o))(m || {}), f = ((o) => (o.SMALL = "small", o.DEFAULT = "default", o.LARGE = "large", o))(f || {});
class e extends v {
  constructor() {
    super(...arguments), this.flavor = "base", this.type = "primary", this.size = "default", this.disabled = !1, this.buttonType = "button";
  }
  onKeyUp(r) {
    this.disabled || r.key !== "Enter" && r.code !== "Enter" || this.dispatchCustomEvent("onClick", {});
  }
  handleClick() {
    if (!this.disabled)
      if (this.buttonType === "submit" || this.buttonType === "reset") {
        const r = this.closest("form");
        r && r.dispatchEvent(new Event(this.buttonType, { bubbles: !0, cancelable: !0 }));
      } else
        this.dispatchCustomEvent("onClick", {});
  }
  render() {
    return x`
      <button
        role="button"
        type=${this.buttonType}
        class=${b({ button: !0, "button--base": this.flavor === "base", "button--branded": this.flavor === "branded", "button--risky": this.flavor === "risky", "button--tab": this.flavor === "tab", "button--periwinkle": this.flavor === "periwinkle", "button--primary": this.type === "primary", "button--secondary": this.type === "secondary", "button--tertiary": this.type === "tertiary", "button--size-small": this.size === "small", "button--size-default": this.size === "default", "button--size-large": this.size === "large" })}
        aria-disabled=${this.disabled}
        tabindex=${this.disabled ? "-1" : "0"}
        ?disabled=${this.disabled}
        part="button ${this.flavor} ${this.size} ${this.type} ${this.disabled ? "disabled" : ""}"
        @keyup=${this.onKeyUp}
        @click=${this.handleClick}
      >
        <div class="button--content">
          <slot name="prefix"></slot>
          <slot></slot>
        </div>
        <slot name="suffix"></slot>
      </button>
    `;
  }
}
e.styles = h, t([d(".button")], e.prototype, "button", 2), t([n()], e.prototype, "flavor", 2), t([n()], e.prototype, "type", 2), t([n()], e.prototype, "size", 2), t([n({ type: Boolean, reflect: !0 })], e.prototype, "disabled", 2), t([n({ type: String })], e.prototype, "buttonType", 2);
const C = g("ex-button", e);
export {
  y as B,
  f as a,
  m as b,
  e as c,
  C as r
};
